var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "custom-collapse",
        { staticClass: "px-4", attrs: { id: "rubric-questions-collapse" } },
        _vm._l(_vm.value, function(item, key) {
          return _c(
            "custom-collapse-item",
            {
              key: `question-collapse-item-${key + 1}`,
              ref: `question-collapse-item-${key + 1}`,
              refInFor: true,
              staticClass: "my-3 collapse-item question bg-white",
              class: { "rounded invalid": item.valid === false },
              attrs: {
                id: `question-collapse-item-${key + 1}`,
                "auto-expand-collapse-enabled": false,
                "button-icon":
                  _vm.value.length > 1 ? "far fa-times-circle color-red" : "",
                "component-key": key,
                disabled: _vm.isReadOnly,
                expanded: item.expanded,
                "expanded-icon": "fas fa-plus-circle custom-reorganize-btn",
                "icon-class-when-button-disabled":
                  "fas fa-grip-vertical flex-fill d-flex justify-content-end align-items-center",
                "keep-btn-visible": false,
                "parent-id": "rubric-questions-collapse",
                "read-only-icon": "fas fa-plus-circle color-gray-2",
                title: _vm.getQuestionTitle(item, key)
              },
              on: {
                actionButtonClick: function($event) {
                  return _vm.quit(key)
                },
                expandButtonClick: function($event) {
                  return _vm.expand(item, key)
                }
              }
            },
            [
              _c(
                "validation-observer",
                { ref: `question-${key}`, refInFor: true },
                [
                  _c(
                    "div",
                    { staticClass: "mb-3" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El subtítulo es requerido.",
                                      error: errors[0],
                                      label: "Subtítulo de Sección:",
                                      placeholder: "Subtítulo de Sección"
                                    },
                                    model: {
                                      value: item.name,
                                      callback: function($$v) {
                                        _vm.$set(item, "name", $$v)
                                      },
                                      expression: "item.name"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "my-3" },
                    [
                      _c("custom-text-area", {
                        attrs: {
                          "count-classes": ["d-block", "small-counter"],
                          label: "Notas:",
                          maxlength: 3000,
                          placeholder: "Escribe una Nota",
                          "show-char-count": ""
                        },
                        model: {
                          value: item.notes,
                          callback: function($$v) {
                            _vm.$set(item, "notes", $$v)
                          },
                          expression: "item.notes"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "my-3" }, [
                    _c("div", { staticClass: "data-title" }, [
                      _vm._v(" Valor de Expectativas ")
                    ]),
                    _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(item.answers, function(answer) {
                        return _c(
                          "div",
                          {
                            key: answer.answerId,
                            staticClass: "col-12 col-md"
                          },
                          [
                            _c("div", { staticClass: "card expectative" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "card-header",
                                  style: {
                                    borderBottom: `4px solid ${answer.color ||
                                      "red"} !important`
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("empty")(answer.text)) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "card-body" },
                                [
                                  _c("validation-provider", {
                                    attrs: { rules: "min_value:0|required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ errors }) {
                                            return [
                                              _c("custom-input", {
                                                attrs: {
                                                  "custom-error-msg":
                                                    "El campo es requerido",
                                                  error: errors[0],
                                                  min: 0,
                                                  type: "number"
                                                },
                                                model: {
                                                  value: answer.value,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      answer,
                                                      "value",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression: "answer.value"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ]
              )
            ],
            1
          )
        }),
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end pr-2" },
        [
          _c("action-button", {
            attrs: {
              i: "fas fa-file-plus",
              text: "Añadir Sub-Sección",
              variant: "success"
            },
            on: { click: _vm.add }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }